import React from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';

const TabTitle = (props) => {
    const { title } = props;
    return (
        <Box>
            <Helmet>
                <title>{`${title}`}</title>
            </Helmet>
        </Box>
    )
};

export default TabTitle;